// src/components/Team/userCard/UserArrayPreview.jsx
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./UserArrayPreview.module.scss";

import { GrAddCircle } from "react-icons/gr";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { BiMailSend } from "react-icons/bi";

const UserArrayPreview = ({
  user,
  roleLabel = "—",
  inviteCount = 0,
  usersCount = 0,
  expanded = false,
  onToggle,
  onInviteClick,
}) => {
  const [mobile, setMobile] = useState(false);
  const [showInfos, setShowInfos] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => setMobile(window.innerWidth < 950);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // ✅ hooks toujours appelés, même si user est null
  const title = user?.display_name || user?.user_login || t("team.user_default");
  const subtitle = user?.user_email || "—";

  const remainingUsers = useMemo(() => {
    const total = Number.isFinite(usersCount) ? usersCount : 0;
    return Math.max(0, total - (user ? 1 : 0));
  }, [usersCount, user]);

  // ✅ return conditionnel APRES les hooks
  if (!user) return null;

  return (
    <div className={styles.containerTeam}>
      <h3>{t("team.my_team")}</h3>

      <div className={styles.card}>
        <div className={styles.topRow}>
          <div className={styles.titleBlock}>
            <h4 className={styles.username} title={title}>
              {title}
            </h4>

            <div className={styles.subInfo} title={subtitle}>
              {subtitle}
            </div>

            <div className={styles.roleLine}>
              <span className={styles.rolePill}>{roleLabel}</span>
              <span className={styles.idText}>ID: {user?.ID ?? "—"}</span>
            </div>
          </div>

          <div className={styles.rightActions}>
            {inviteCount > 0 && (
              <button
                type="button"
                className={`${styles.inviteBadge} has-tooltip`}
                onClick={onInviteClick || onToggle}
                aria-label={t("team.see_pending_invitations")}
              >
                <BiMailSend />
                <span>{inviteCount}</span>
              </button>
            )}

            {mobile && (
              <button
                className={`${styles.iconBtn} has-tooltip`}
                type="button"
                onClick={() => onToggle?.()}
                aria-label={expanded ? t("team.collapse") : t("team.expand")}
              >
                <GrAddCircle />
              </button>
            )}

            <div className={styles.infoWrap}>
              <IoMdInformationCircleOutline
                className={`${styles.infoIcon} has-tooltip`}
                onMouseEnter={() => setShowInfos(true)}
                onMouseLeave={() => setShowInfos(false)}
                onClick={() => setShowInfos((v) => !v)}
                aria-label={t("team.info")}
              />
              {showInfos && (
                <div className={styles.bubble}>
                  <div className={styles.bubbleTitle}>{t("team.preview")}</div>
                  <div className={styles.bubbleText}>
                    {t("team.preview_description")}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className={styles.footer}>
         
        </div>
      </div>

      {(remainingUsers > 0 || inviteCount > 0) && (
  <div className={styles.moreWrapper}>
  <div className={styles.moreHint}>
    {remainingUsers > 0 ? (
      <>
        {t("team.other_users", { count: remainingUsers })}
      </>
    ) : (
      <>{t("team.no_other_user")}</>
    )}

    {" • "}

    {inviteCount > 0 ? (
      <>
        {t("team.pending_invitations", { count: inviteCount })}
      </>
    ) : (
      <>{t("team.no_pending_invitation")}</>
    )}
  </div>

  <button type="button" className={styles.moreBtn} onClick={onToggle}>
    {t("team.show_my_team")}
  </button>
</div>

      )}
    </div>
  );
};

export default UserArrayPreview;
